import chinaJSON from './china.json';
import loginBg from './login-bg.png';

export default {
  chinaJSON,
  loginBg,
};



// WEBPACK FOOTER //
// ./src/assets/index.js